var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPencilCircle = function SvgIconPencilCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.078 20.707a1 1 0 0 1-.152-.088A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 3.67-1.978 6.88-4.926 8.619a1 1 0 0 1-.152.088A9.95 9.95 0 0 1 12 22c-1.79 0-3.469-.47-4.922-1.293M12 4a8 8 0 0 0-5.5 13.81V16.5a1 1 0 0 1 .092-.42l4.5-9.75a1 1 0 0 1 1.816 0l4.5 9.75a1 1 0 0 1 .092.42v1.31A8 8 0 0 0 12 4m3.5 15.196a8 8 0 0 1-2.5.742V18.75a1.25 1.25 0 0 1 2.5 0zM14.25 15.5a3.25 3.25 0 0 0-2.25.905 3.25 3.25 0 0 0-2.975-.823l.846-1.832h4.258l.846 1.832a3.3 3.3 0 0 0-.725-.082m-1.044-3.75L12 9.136l-1.206 2.614zm-4.34 6.116a1.25 1.25 0 0 0-.366.884v.446a8 8 0 0 0 2.5.742V18.75a1.25 1.25 0 0 0-2.134-.884",
    clipRule: "evenodd"
  })));
};
export default SvgIconPencilCircle;